import * as fromReducer from './timezone-info.reducer';

import { SettingsStateKeys } from '@libs/entity-lib';
import { createFeatureSelector, createSelector } from '@ngrx/store';

export const selectTimezoneState = createFeatureSelector<fromReducer.State>(
  SettingsStateKeys.TIMEZONE
);

export const selectSportCenterTimezone = createSelector(
  selectTimezoneState,
  (state) => state?.timezone
);

export const selectLocalDateTimeTimezone = createSelector(
  selectTimezoneState,
  (state) => state?.localDateTime
);

export const selectAllTimezones = createSelector(
  selectTimezoneState,
  (state) => state?.timezones ?? []
);

export const selectSportCenterTimezoneIsLoading = createSelector(
  selectTimezoneState,
  (state) => state?.loading
);

export const selectSportCenterTimezoneError = createSelector(
  selectTimezoneState,
  (state) => state?.error
);
